// extracted by mini-css-extract-plugin
export default {"searchbar":"Searchbar_searchbar__6UI1w"};